var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pd-VendorVideo_OuterWrapper"},[(_vm.visible)?_c('div',{staticClass:"pd-VendorVideo_Wrapper"},[_vm._t("default")],2):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }